import { Component } from '@angular/core';

@Component({
  selector: 'app-page-in-development',
  templateUrl: './page-in-development.component.html',
  styleUrls: ['./page-in-development.component.scss']
})
export class PageInDevelopmentComponent {

}
